export default __webpack_public_path__ + "static/about2-ad7e2a9a01d392321fba14b2f44e606d.png";